import React from 'react';
import { useGetActingDetail } from '@area-restrita/api-client/endpoints/actings/actings.gen';

import ActingDetailsView from './view';
import ActingDetailsError from './ActingDetailsError';
import ActingDetailsSkeleton from './ActingDetailsSkeleton';
import { getActingRefreshInterval } from './actingDetailsPresentation';

interface IProps {
  actingId: string;
}

const ActingDetails: React.FC<IProps> = ({ actingId }) => {
  const {
    data: acting,
    isError,
    isLoading,
    isRefetchError,
    refetch,
  } = useGetActingDetail(actingId, {
    query: {
      refetchInterval: (query) =>
        getActingRefreshInterval(query.state.data?.status),
    },
  });

  if (isLoading) return <ActingDetailsSkeleton />;

  if (isError && !acting) {
    return <ActingDetailsError onRetry={() => refetch()} />;
  }

  if (!acting) return <ActingDetailsError onRetry={() => refetch()} />;

  return <ActingDetailsView acting={acting} refreshFailed={isRefetchError} />;
};

export default ActingDetails;
